/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nudge_Plan_First_Meeting_BodyInputs */



/**
* | output |
* | --- |
* | "Your agenda is still empty. Put your first conversation in it, and we will prepare it together." |
*
* @param {Nudge_Plan_First_Meeting_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const nudge_plan_first_meeting_body = /** @type {((inputs?: Nudge_Plan_First_Meeting_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nudge_Plan_First_Meeting_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Je agenda is nog leeg. Zet je eerste gesprek erin, dan bereiden we het samen voor.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Votre agenda est encore vide. Ajoutez-y votre première conversation, et nous la préparerons ensemble.")
	return /** @type {LocalizedString} */ ("Your agenda is still empty. Put your first conversation in it, and we will prepare it together.")
});